import React from 'react';

type ReceiptRowV6Props = {
    value?: string | React.JSX.Element | Function,
    subvalue?: string | React.JSX.Element | Function,
    classes?: string[]
}

const ReceiptRowV6 = (props: ReceiptRowV6Props) => {

    let classes = ['receipt-row-v6'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    const renderValue = (): string | React.JSX.Element => {
        if (props.value === undefined) {
            return <></>;
        }

        return (
            <div className="receipt-row-v6__value">
                {(typeof props.value === 'function') ? props.value() : props.value}
            </div>
        );
    }

    const renderSubvalue = (): string | React.JSX.Element => {
        if (props.subvalue === undefined) {
            return <></>;
        }

        return (
            <div className="receipt-row-v6__subvalue">
                {(typeof props.subvalue === 'function') ? props.subvalue() : props.subvalue}
            </div>
        );
    }

    return (
        <div className={classes.join(' ')}>
            {renderValue()}
            {renderSubvalue()}
        </div>
    );

}

export default ReceiptRowV6;